
import "./CourtInforCardCss.css";

interface CourtInfoCardProps {
  court_reg: string;
  type: string;
  date: string;
  court_info: string;
  court_name?: string | null;
  court_level?: string | null;
  court_region?: string | null;
  court_zone?: string | null;
  court_woreda?: string | null;
}

export default function CourtInfoCard({
  court_reg,
  type,
  date,
  court_info,
  court_name,
  court_level,
  court_region,
  court_zone,
  court_woreda,
}: CourtInfoCardProps) {
  return (
    <div className="court-card-container w-full">
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col">
          <p className="court-card-label">Court Registration</p>
          <p className="court-card-value">{court_reg}</p>
        </div>
        <div className="flex flex-col">
          <p className="court-card-label">Type</p>
          <p className="court-card-value">{type}</p>
        </div>
        <div className="flex flex-col p-2 rounded bg-black text-white text-sm">
          <p>Appointment Date</p>
          <p className="text-sm text-white">{date}</p>
        </div>
      </div>
      
      <div className="mt-3">
        <p className="court-card-title mb-2 font-semibold" style={{fontWeight:"600 "}}>Court Full Information</p>
      </div>

      {/* Court Details - Label and Value in one row horizontally */}
      <div className="mt-2 space-y-2">
        {court_name && (
          <div className="flex items-center gap-3 justify-between w-full">
            <span className="court-card-label min-w-[100px]">Court Name:</span>
            <span className="court-card-value">{court_name}</span>
          </div>
        )}
        {court_level && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Court Level:</span>
            <span className="court-card-value">{court_level}</span>
          </div>
        )}
        {court_region && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Region:</span>
            <span className="court-card-value">{court_region}</span>
          </div>
        )}
        {court_zone && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Zone:</span>
            <span className="court-card-value">{court_zone}</span>
          </div>
        )}
        {court_woreda && (
          <div className="flex items-center gap-3 w-full justify-between">
            <span className="court-card-label min-w-[100px]">Woreda:</span>
            <span className="court-card-value">{court_woreda}</span>
          </div>
        )}
      </div>
    </div>
  );
}